import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Input from '../../../module/input'
import { manageActions, alertActions } from '../../../store/actions'
import { valid } from '../../../hook/valid'

/** 초대하기
 * 신규 사용자 초대 팝업
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const InvtPopup = (props) => {
  const [state, setState] = useState({
    userName: '', // 사용자 이름 valid
    email: '', // 사용자 이메일 valid
  })

  // useEffect(() => {
  //   if (props.isUpdate) {
  //     // 전송 성공시
  //     props.success({
  //       title: '초대하기성공',
  //       message: '초대하기가 성공하였습니다.',
  //       params: {
  //         type: 'SUCCESS',
  //         callback: () => {
  //           window.location.reload()
  //         },
  //       },
  //     })
  //   }
  // }, [props.isUpdate])

  // useEffect(() => {
  //   if (props.isFailure) {
  //     // 전송 실패시
  //     props.success({
  //       title: '초대하기실패',
  //       message: '초대하기가 실패하였습니다.\n' + props.errorMessage,
  //       params: {
  //         type: 'ERROR',
  //         callback: () => {
  //           window.location.reload()
  //         },
  //       },
  //     })
  //   }
  // }, [props.isFailure])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const onInsert = () => {
    let paramObj = {
      groupCode: props.groupCode,
      userName: state.userName,
      email: state.email,
    }

    // 이름이랑 메일 잘 입력했는지 유효성 체크
    if (props.checkFindInput({ email: paramObj.email, name: paramObj.userName })) {
      props.updateManageUser(paramObj)
    }
  }

  // 팝업 style
  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '997',
  }
  let styleModal = {
    position: 'absolute',
    display: 'block',
    opacity: '1',
    zIndex: '998',
  }

  return (
    <React.Fragment>
      <div style={style}></div>
      <div id="invt-info" className="modal w450" style={styleModal}>
        <div className="modal-head">
          <h2>이메일 발송</h2>
        </div>
        <div className="modal-cont">
          <dl className="dl-form">
            <dt>이름</dt>
            <dd>
              <Input
                type="text"
                className="form-control"
                placeholder="이름을 입력해주세요"
                id="userName"
                name="userName"
                value=""
                onChange={handleChange}
              />
            </dd>
            <dt>이메일</dt>
            <dd>
              <Input
                type="text"
                className="form-control"
                placeholder="이메일을 입력해주세요"
                id="email"
                name="email"
                value=""
                onChange={handleChange}
              />
            </dd>
          </dl>
          <div className="btn-block center">
            <a
              href="#"
              className="btn-secondary md b-close"
              onClick={() => {
                props.onChange(false)
              }}
            >
              취소
            </a>
            <a href="#" className="btn-primary md b-close" onClick={onInsert}>
              확인
            </a>
          </div>
        </div>
        <button
          onClick={() => {
            props.onChange(false)
          }}
          type="button"
          className="modal-close b-close"
        >
          창닫기
        </button>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  isUpdate: state.manage.isUpdate,
  isFailure: state.manage.isFailure,
  errorMessage: state.manage.errorMessage,
})

const mapDispatchToProps = {
  checkFindInput: valid.checkFindInput,
  updateManageUser: manageActions.updateManageUser,
  getGroupInfo: manageActions.getGroupInfo,
  readInviteList2: manageActions.readInviteList2,
  error: alertActions.error,
  success: alertActions.success,
}

export default connect(mapStateToProps, mapDispatchToProps)(InvtPopup)
